export const setSkillsStatusState = state => {
    return {
      type: "SET_SKILLSSTATUS_STATE",
      payload: state,
    };
  };